import { useState } from "react";
import xCircleIcon from "../../assets/icons/exit-icon.svg";
import { useStores } from "../../use.store";
import { submitApplicationFeedBack } from "../../services/submitFeedback";
import thankYouIcon from "../../assets/images/thank-you-logo.png";

export default function ModalFeedback({ onclose }) {
  const { mainStore } = useStores();
  const [rating, setRating] = useState(0);
  const [comments, setComments] = useState("");
  const [isOpen, setIsOpen] = useState(true);
  const [isPostFeedbackSuccess, setIsPostFeedbackSuccess] = useState(false);

  const stars = [1, 2, 3, 4, 5];

  const handleStarClick = (starValue) => {
    setRating(starValue);
  };

  const handleSubmit = async () => {
    const resp = await submitApplicationFeedBack(
      mainStore.config.baseUrl,
      mainStore.config.email,
      mainStore.config.password,
      mainStore.config.adsignId,
      rating,
      comments,
      "68ae9232cd4ca570705e11ea"
    );
    setIsPostFeedbackSuccess(resp);

    // Handle form submission here
    // setIsOpen(false);
  };

  return (
    <div className="fixed flex flex-col gap-y-5 inset-0 bg-black bg-opacity-50 flex items-center justify-center z-20">
      <div
        className="bg-white rounded rounded-xs shadow-xl w-full max-w-[310px]"
        style={{
          marginLeft: "20px",
          marginRight: "20px",
        }}
      >
        <div className="bg-[#215732] text-white p-4 rounded rounded-t-xs flex justify-between items-center">
          <h2 className="text-xl font-bold">
            {mainStore.popupFormHeader ?? "Share Your Feedback"}
          </h2>
          <img src={xCircleIcon} className="flex-shrink-0" onClick={onclose} />
        </div>

        <div className="p-6">
          <div className="mb-6">
            <h3 className="text-black text-base font-medium mb-4">
              {isPostFeedbackSuccess
                ? mainStore.popupFormHeaderThankouMsg
                : mainStore.popupFormHeaderRatingLabel ??
                  "How was the overall user experience?"}
            </h3>
            {!isPostFeedbackSuccess && (
              <div className="flex gap-2">
                {stars.map((star) => (
                  <button
                    key={star}
                    onClick={() => handleStarClick(star)}
                    className={`text-[40px] transition-colors ${
                      star <= rating ? "text-[#FFD029]" : "text-[#EFF0F6]"
                    }`}
                  >
                    ★
                  </button>
                ))}
              </div>
            )}
          </div>

          {isPostFeedbackSuccess ? (
            <div className="flex flex-row w-full items-center justify-center">
              <img src={thankYouIcon} className="w-[180px] h-[180px]" />
            </div>
          ) : (
            <div className="mb-6">
              <h4 className="text-black text-base font-medium mb-3">
                {mainStore.popupFormHeaderCommentLabel ?? "Comments"}
              </h4>
              <textarea
                value={comments}
                onChange={(e) => setComments(e.target.value)}
                placeholder={"Please elaborate on your given rating here"}
                className="w-full h-32 p-3 border border-gray-300 rounded-2xl resize-none focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent placeholder-gray-400"
              />
            </div>
          )}
        </div>
      </div>

      {!isPostFeedbackSuccess && (
        <div className="px-6 pb-6">
          <button
            onClick={handleSubmit}
            className={`w-[120px] ${
              comments && rating > 0
                ? "bg-[#A09200] text-white"
                : "bg-[#D9D9D9] text-[#75787B80]"
            }   py-2 px-4 rounded-md transition-colors font-medium`}
          >
            Submit
          </button>
        </div>
      )}
    </div>
  );
}
